import React from "react";
import { formatAmount } from "@shared/types";

export function Amount({ value, currency, className = "" }: { value: number | string; currency?: string | null; className?: string }) {
  return <span className={`whitespace-nowrap tabular-nums ${className}`}>{formatAmount(value, currency)}</span>;
}
